import { Component } from '@angular/core';
import { Cms } from './models/cms.model';
import { CmsStudioService } from './cms-studio.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';

@Component({
    selector: 'cms',
    templateUrl: './cms.component.html',
    styleUrls: ['cmsstudio.component.css']
})

export class CmsComponent {
    title = 'CMS';
    component: any;
    setFullWindow = false;
    subWidth: string;
    cms: Cms;
    currentUserModel: CurrentUserModel;

    constructor(private router: Router, private ngProgress: NgProgress, private activeRouter: ActivatedRoute, private cmsStudioService: CmsStudioService, private authService: AuthService) { }

    ngOnInit() {
        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.currentUserModel = res;
        this.cmsStudioService.getCmsHomePage(this.currentUserModel.companyCode)
            .subscribe(res => {
                //console.log(res);
                if (res.stat == "success") {
                    this.cms = res.cms;
                }
            })
        });
    }
    navigateTo(url: string) {
        this.router.navigate([url]);
    }
}